<template>
  <div class="flex flex-col h-full justify-between">
    <div class="flex flex-col flex-grow pb-8 lg:pb-4 sm:pb-0 custom-container">
      <MainHeader class="vacancy-top-line" alternativeLogo />
      <VacancyInfo :position="position" :office="office" />
    </div>
    <div class="main custom-container pt-20 pb-20 sm:pt-10 sm:pb-10">
      <VacancyContent class="w-full"/>
    </div>
    <footer class="main-footer min-h-152px bg-primary-100">
      <div
        class="custom-container h-full flex sm:flex-col sm:justify-center sm:space-y-4 justify-between items-center"
      >
        <span v-if="$domain === 'ru'" class="text-white">
          {{ $t('landing.if-you-have-trouble-to-fill-form') }}
        </span>
        <span
          v-else
          class="text-white"
          v-html="$t('landing.if-you-have-trouble-to-fill-form-email')"
        />
        <div v-if="$domain === 'ru'" class="flex justify-between min-w-200px">
          <a
            href="https://vk.com/sm.career"
            class="flex items-center justify-center bg-white w-10 h-10 rounded-full bg-opacity-20"
            target="_blank"
          >
            <img src="@/assets/icons/vkontakte.svg" alt="vkontakte" />
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import MainHeader from '@/components/MainHeader.vue';
import VacancyInfo from '@/components/Vacancy/VacancyInfo.vue';
import VacancyContent from '@/components/Vacancy/VacancyContent.vue';
import { getVacancy } from '@/api';

export default {
  name: 'Vacancy',
  components: {
    MainHeader,
    VacancyInfo,
    VacancyContent,
  },
  data() {
    return {
      position: null,
      office: null,
    };
  },
  async mounted() {
    const { position, office } = this.$route.query;
    const { status, data } = await getVacancy({ position, office });
    if (status === 200) {
      this.position = data.vacancy;
      this.office = data.office;
    }
  },
  computed: {
  },
};
</script>
<style lang="scss">
.vacancy-top-line {
  padding-top: 0;
  padding-bottom: 0;
  @media (max-width: 762px) {
    padding-top: 8px!important;
    padding-bottom: 8px!important;
  }
}
</style>
